import { render, staticRenderFns } from "./ed-context-menu-items.vue?vue&type=template&id=f16fae76&scoped=true&"
import script from "./ed-context-menu-items.ts?vue&type=script&lang=ts&"
export * from "./ed-context-menu-items.ts?vue&type=script&lang=ts&"
import style0 from "./ed-context-menu-items.scss?vue&type=style&index=0&id=f16fae76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16fae76",
  null
  
)

export default component.exports